import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const reindexAeoKnowledge = unaryRpc({
  name: "reindexAeoKnowledge",
  input: z.object({}),
  output: z.object({ workflowId: z.string(), status: z.literal("started") }),
});
